import { REDUX_STATUS } from '@gymaholic/packages'
import { getObjectUtil } from 'packages/src'

function isSavingReduxSelector (path) {
  return state => getObjectUtil(state, `${path}.status`) === REDUX_STATUS.SAVING
}

export default isSavingReduxSelector
